import { combineReducers } from 'redux';

import vendorDetails from './vendorDetails/reducer';
import page from './page/reducer';
import eleFileConfig from './eleFileConfig/reducer';

export default combineReducers({
  vendorDetails,
  page,
  eleFileConfig,
});



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/state/reducer.js